module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row preview-form-parent justify-content-center"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "row preview-form-parent justify-content-center"
  }, [_c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-10 col-sm-10 col-md-8 preview-form"
  }, [_c('div', {
    staticClass: "row image-div-row"
  }, [_c('div', {
    staticClass: "col-10 col-sm-11 col-md-11 image-div center-block"
  }, [_c('img', {
    staticClass: "form-image",
    attrs: {
      "src": _vm.form.image,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', {
    staticClass: "text-align-center"
  }, [_vm._v(_vm._s(_vm.form.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 center-block text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.form.description))])])]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "col-12 preview-ul"
  }, _vm._l((_vm.form.fields), function(field, index) {
    return _c('li', {
      staticClass: "form-fields form-line"
    }, [(field.type.name == 'input' && field.element.name == 'text') ? _c('div', {
      staticClass: "row form-group form-material"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                                      " + _vm._s(field.label) + "\n                                                      "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      staticClass: "form-control border-0",
      attrs: {
        "id": field.type.name + index,
        "type": "text",
        "required": field.mandatory == 1
      }
    })])]) : _vm._e(), _vm._v(" "), (field.type.name == 'input' && (field.element.name == 'email' || field.element.name == 'password')) ? _c('div', {
      staticClass: "row form-group form-material"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                                      " + _vm._s(field.label) + "\n                                                      "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      staticClass: "form-control border-0",
      attrs: {
        "id": field.type.name + index,
        "type": field.element.name,
        "required": field.mandatory == 1
      }
    })])]) : _vm._e(), _vm._v(" "), (field.type.name == 'input' && (field.element.name == 'checkbox' || field.element.name == 'radio')) ? _c('div', {
      staticClass: "row form-group form-material"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('label', {
      staticClass: "control-label form-label form-label-left form-label-auto",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                                      " + _vm._s(field.label) + "\n                                                      "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _vm._l((field.select_options), function(option, i) {
      return _c('div', {
        staticClass: "options"
      }, [_c('input', {
        attrs: {
          "id": field.type.name + i,
          "type": field.element.name,
          "name": option.label,
          "required": field.mandatory == 1
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "control-label",
        attrs: {
          "for": field.type.name + index
        }
      }, [_vm._v("\n                                                        " + _vm._s(option.name) + "\n                                                      ")])])
    })], 2)]) : _vm._e(), _vm._v(" "), (field.type.name == 'input' && field.element.name == 'time' && field.model == 'time_in') ? _c('div', {
      staticClass: " form-group form-material"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("\n                                                    " + _vm._s(field.label) + "\n                                                    "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.rentalTimeIn),
        expression: "rentalTimeIn"
      }],
      staticClass: "form-control",
      attrs: {
        "required": field.mandatory == 1
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.rentalTimeIn = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.timeInHours), function(i) {
      return _c('option', {
        domProps: {
          "value": i
        }
      }, [_vm._v(_vm._s(i))])
    }))])])]) : _vm._e(), _vm._v(" "), (field.type.name == 'input' && field.element.name == 'time' && field.model == 'time_out') ? _c('div', {
      staticClass: " form-group form-material"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("\n                                                    " + _vm._s(field.label) + "\n                                                    "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.rentalTimeOut),
        expression: "rentalTimeOut"
      }],
      staticClass: "form-control",
      attrs: {
        "required": field.mandatory == 1
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.rentalTimeOut = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.timeOutHours), function(i) {
      return _c('option', {
        domProps: {
          "value": i
        }
      }, [_vm._v(_vm._s(i))])
    }))])])]) : _vm._e(), _vm._v(" "), (field.type.name == 'input' && field.element.name == 'date') ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("\n                                                        " + _vm._s(field.label) + "\n                                                        "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('datepicker', {
      staticClass: "form-control",
      attrs: {
        "id": "check-in",
        "format": "dd D MMMM yyyy"
      }
    })], 1)])]) : _vm._e(), _vm._v(" "), (field.type.name == 'select') ? _c('div', {
      staticClass: "row form-group form-material"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                                      " + _vm._s(field.label) + "\n                                                      "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
      staticClass: "form-control",
      attrs: {
        "id": "field.type.name+index"
      }
    }, [_c('option', {
      attrs: {
        "selected": ""
      }
    }, [_vm._v("Please select " + _vm._s(field.label))]), _vm._v(" "), _vm._l((field.select_options), function(option, i) {
      return _c('option', {
        attrs: {
          "id": field.type.name + i,
          "type": field.element.name,
          "name": option.label,
          "required": field.mandatory == 1
        }
      }, [_vm._v("\n                                                        " + _vm._s(option.name) + "\n                                                      ")])
    })], 2)])]) : _vm._e(), _vm._v(" "), (field.type.name === 'textarea') ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                                        " + _vm._s(field.label) + "\n                                                        "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {}, [_c('span', {
      staticClass: "form-sub-label-container",
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('textarea', {
      staticClass: "form-control",
      attrs: {
        "cols": "100",
        "rows": "6",
        "id": field.label + index,
        "required": "required",
        "data-component": "textarea"
      }
    })])])]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row buttons-row"
  }, [_c('div', {
    staticClass: "m-auto"
  }, [_c('button', {
    staticClass: "btn send-button",
    attrs: {
      "id": "clear-form",
      "type": "reset"
    }
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t('button.clear_form')) + "\n                                        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-red send-button",
    attrs: {
      "id": "submit",
      "type": "submit"
    }
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t('button.submit')) + "\n                                        ")])])])])])])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-467478e3"}!./src/app/pages/form/preview/index.html
// module id = 1360
// module chunks = 0